import * as d3 from "d3";
import {colonAnnotation, fw_progressive_1way, inrFormatter, numberFormat, responsivefy} from '../functions'

export default function (chart, divId,vizName, resData) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    //var tempVar = chart.tempVar

    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName;


    // Data structure describing chart scales
    let Scales = {
        lin: "scaleLinear",
        log: "scaleLog"
    };

    // Data structure describing volume of displayed data
    let Count = {
        metric1: "metric1",
        perCap: "metric2"
    };

    // Data structure describing legend fields value
    let Legend = {
        metric1: "Total Margins",
    };

    var chartState = {};
    chartState.measure = Count.metric1;
    chartState.scale = Scales.lin;
    chartState.legend = Legend.metric1;

    let svg = d3.select(divId).select("svg").remove();
    svg = d3.select(divId)
        .append("svg")
        .attr("width", chart.width)
        .attr("height", chart.height + (chart.margin.top + chart.margin.bottom))
        .call(responsivefy)
        .append('g')
        .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')');

    let x1AxisLabel = d3.scaleLinear().range([chart.margin.left, chart.width - chart.margin.right]);

    svg.append("g")
        .attr("class", "x axis")
        .attr("transform", "translate(0," + (chart.height - chart.margin.bottom) + ")");

    // Create tooltip div and make it invisible
    /*d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element // appended with divId to make it unique
  var y1tip = tooltip_class()

  y1tip.attr('class', 'd3-tip'+divId.id).html((d) =>{
        return (`${d.dim2_name} <br/> ${d.dim1_name}${colonAnnotation} ${numberFormat(d.metric1)}`)
     })

  svg.call(y1tip);*/

    d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
    var div = d3.select(divId).append('div').attr('class', 'tooltip')
        .attr('style', 'position: absolute; opacity: 0;')

    // Load and process data
    // axios.post(url, filterParam).then(res => {
        let data = resData;
        let dataSet = data;
        // Set chart domain max value to the highest total value in data set
        let sumstat = d3.nest().key(d => {
            return d.dim1_name
        }).sortKeys(d3.ascending).entries(data)

        x1AxisLabel.domain(d3.extent(data, (d) => {
            return +d.metric1
        }));

        let metric1ColorScale = d3.scaleOrdinal().domain(sumstat).range(fw_progressive_1way);

        redraw();

        svg.append('text')
            .attr('x', (chart.width / 3))
            .attr('y', chart.height + chart.margin.bottom - chart.axisLabelDistance)
            .style('fill', fontColor)
            .text(chart.x1AxisDisplayName)
            .style('font-size', fontSize)

        // Listen to click on "total" and "per capita" buttons and trigger redraw when they are clicked
        d3.selectAll(".measure").on("click", function () {
            let thisClicked = this.value;
            chartState.measure = thisClicked;
            if (thisClicked === Count.metric1) {
                chartState.legend = Legend.metric1;
            }
            if (thisClicked === Count.perCap) {
                chartState.legend = Legend.perCap;
            }
            redraw();
        });

        // Listen to click on "scale" buttons and trigger redraw when they are clicked
        d3.selectAll(".scale").on("click", function () {
            chartState.scale = this.value;
            redraw(chartState.measure);
        });

        // Trigger filter function whenever checkbox is ticked/unticked
        d3.selectAll("input").on("change", filter);

        function redraw() {
            // Set scale type based on button clicked
            if (chartState.scale === Scales.lin) {
                x1AxisLabel = d3.scaleLinear().range([chart.margin.left, chart.width - chart.margin.right])
            }
            if (chartState.scale === Scales.log) {
                x1AxisLabel = d3.scaleLog().range([chart.margin.left, chart.width - chart.margin.right]);
            }
            x1AxisLabel.domain(d3.extent(dataSet, (d) => {
                return +d[chartState.measure]
            }));

            let x2AxisLabel = d3.axisBottom(x1AxisLabel)
                .tickFormat(inrFormatter)
                .ticks(10)
                .tickSizeOuter(0);

            svg.append('g')
                .attr('class', 'x axis')
                .style("font-size", "15px")
                .attr('transform', 'translate(0,' + chart.height + ')')
                .call(x2AxisLabel)

            // Create simulation with specified dataset
            let simulation = d3.forceSimulation(dataSet)
                .force("x", d3.forceX(function (d) {
                    return x1AxisLabel(+d[chartState.measure]);  // This is the desired position
                }).strength(2))  // Increase velocity
                .force("y", d3.forceY((chart.height / 2) - chart.margin.bottom / 2))  // Apply positioning force to push nodes towards center along Y axis
                .force("collide", d3.forceCollide(9)) // Apply collision force with radius of 9 - keeps nodes centers 9 pixels apart
                .stop();  // Stop simulation from starting automatically

            // Manually run simulation
            for (let i = 0; i < dataSet.length; ++i) {
                simulation.tick(10);
            }
            // Create country circles
            let countriesCircles = svg.selectAll(".countries")
                .data(dataSet, function (d) {
                    return d.dim1_name
                });

            countriesCircles.exit()
                .transition()
                .duration(1000)
                .attr("cx", 0)
                .attr("cy", (chart.height / 2) - chart.margin.bottom / 2)
                .remove();

            countriesCircles.enter()
                .append("circle")
                .attr("class", "countries")
                .attr("cx", 0)
                .attr("cy", (chart.height / 2) - chart.margin.bottom / 2)
                .attr("r", 6)
                .attr("fill", function (d) {
                    return metric1ColorScale(d.dim2_name)
                })
                .merge(countriesCircles)
                .transition()
                .duration(2000)
                .attr("cx", function (d) {
                    return d.x;
                })
                .attr("cy", function (d) {
                    return d.y;
                });

            // Show tooltip when hovering over circle (data for respective country
            d3.selectAll(".countries")
                .on("mousemove", function (d) {
                    console.log(d3.event, d)
                    div.transition()
                        .duration(200)
                        .style("opacity", .9);
                    div.html(`${d.dim2_name} <br/> ${d.dim1_name}${colonAnnotation} ${numberFormat(d.metric1)}`)
                        .style("left", (d3.event.layerX) + "px")
                        .style("top", (d3.event.layerY) + "px");
                })
                .on("mouseout", function () {
                    div.transition().style("opacity", 0)
                });
            //.on("mousemove", y1tip.show)
            //.on("mouseout", y1tip.hide)
            //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding
        }

        // Filter data based on which checkboxes are ticked
        function filter() {
            function getCheckedBoxes(checkboxName) {
                let checkboxes = d3.selectAll(checkboxName).nodes();
                let checkboxesChecked = [];
                for (let i = 0; i < checkboxes.length; i++) {
                    if (checkboxes[i].checked) {
                        checkboxesChecked.push(checkboxes[i].defaultValue);
                    }
                }
                return checkboxesChecked.length > 0 ? checkboxesChecked : null;
            }

            let checkedBoxes = getCheckedBoxes(".continent");
            let newData = [];

            if (checkedBoxes == null) {
                dataSet = newData;
                redraw();
                return;
            }

            for (let i = 0; i < checkedBoxes.length; i++) {
                let newArray = data.filter(function (d) {
                    return d.dim2_name === checkedBoxes[i];
                });
                Array.prototype.push.apply(newData, newArray);
            }

            dataSet = newData;
            redraw();
        }

        let legendText = d3.nest()
            .key(d => {
                return d.dim2_name
            })
            .sortKeys(d3.ascending).entries(data)
        let y1legend = svg.append('g')
            .selectAll('g')
            .data(legendText)
            .enter()
            .append('g')
            .attr('transform', (d, i) => 'translate(0,' + i * 20 + ')')

        y1legend.append('circle')
            .attr('cx', chart.width - 5 * chart.margin.right - 20)
            .attr('cy', 6)
            .attr('r', 5)
            .attr('fill', d => {
                return metric1ColorScale(d.key)
            })

        y1legend.append('text')
            .data(legendText, (d) => {
                return d.key
            })
            .attr('x', chart.width - 5 * chart.margin.right)
            .attr('y', 5)
            .attr('dy', '0.32em')
            .attr('fill', 'black')
            .text((d) => {
                return d.key
            })
    // }).catch(function (error) {
    //     if (error) throw error;
    // });
}
